import { render, staticRenderFns } from "./OptOutSaleAction.vue?vue&type=template&id=f4f927fe&"
import script from "./OptOutSaleAction.vue?vue&type=script&lang=ts&"
export * from "./OptOutSaleAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports